import AscHeading from "../../../AscTypography/AscHeading/AscHeading";
import { EditIcon, TrashIcon, TwoMoreIcon } from "../../../AscIcons";
import classNames from "classnames";
import styles from "./AscFeedbackPreviewField.module.scss";

export interface AscFeedbackPreviewFieldProps {
  className?: string;
  title?: string;
  selected?: boolean;
  hasError?: boolean;
  onEditClick?: any;
  onDeleteClick?: any;
}

export default function AscFeedbackPreviewField({
  className,
  title,
  selected,
  onEditClick,
  onDeleteClick,
  hasError = false,
}: AscFeedbackPreviewFieldProps) {
  return (
    <div
      className={classNames(
        styles.ground,
        selected && styles.selected,
        hasError && styles.hasError,
        className
      )}
    >
      <div className={styles.leftSection}>
        <TwoMoreIcon className={styles.moreIcon} />
        <AscHeading className={styles.title} level={6}>
          {title || "Undefined"}
        </AscHeading>
      </div>

      <div className={styles.rightSection}>
        <EditIcon className={styles.icon} onClick={onEditClick} />
        <TrashIcon className={styles.icon} onClick={onDeleteClick} />
      </div>
    </div>
  );
}
